import { render, staticRenderFns } from "./codeBind.vue?vue&type=template&id=12ff5909&scoped=true"
import script from "./codeBind.vue?vue&type=script&lang=js"
export * from "./codeBind.vue?vue&type=script&lang=js"
import style0 from "./codeBind.vue?vue&type=style&index=0&id=12ff5909&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ff5909",
  null
  
)

export default component.exports